import { Component, OnInit, ViewChild, TemplateRef, AfterViewInit, Input, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ApiService } from 'src/app/service/api.service';
import { catchError, map, debounceTime, switchMap } from 'rxjs/operators';
import { Login } from 'src/app/model/login';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-liberacaomanual-popup',
  templateUrl: './liberacaomanual-popup.component.html',
  styleUrls: [
    '../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
    '../../../vendor/libs/ng-select/ng-select.scss',
    '../../../vendor/libs/ngb-datepicker/ngb-datepicker.scss'
  ]
})
export class LiberacaoManualPopupComponent implements OnInit {

  //#region VARIABLE
  // https://gist.github.com/ux-powered/c47614ec346517a6c17306733574ecdb
  isRTL: boolean;
  user: Login;
  autorizado_por: any = null;
  loadedLocaisAcessos: boolean = false;

  id: number = 0;
  loading = [false];
  submitted = false;
  numberOfItemsFromEndBeforeFetchingMore = 5;

  @Input() dispositivoView: any;
  @Input() usuarioView: any;
  @Input() veiculoView: any;

  state: any = {
    is404: [false, false],
    dispositivos: null,
    leitores: null,
    usuarios: null,
    dispositivoView: null
  }

  typeaheadAutorizadoPor = new EventEmitter<string>();
  typeaheadDispositivo = new EventEmitter<string>();

  public form: FormGroup;

  get f() {
    return this.form.controls;
  }

  //#endregion

  //#region CONSTRUCTOR
  constructor(private modalService: NgbModal, public activeModal: NgbActiveModal, public translateService: TranslateService,
    private appService: AppService,
    private apiService: ApiService, private fb: FormBuilder, private cd: ChangeDetectorRef,
    private router: Router) {

    this.isRTL = appService.isRTL;

    this.apiService.getUser().then((res: Login) => {
      this.user = res;
    });

  }

  ngOnInit(): void {

    this.form = this.fb.group({

      fk_idveiculo: [null],
      fk_idusuario: [null],
      fk_idsetor: [null],
      fk_idconta: [null],
      fk_iddispositivo: [null, [Validators.required]],
      fk_idleitor: [null], // coluna não existe no banco, apenas para uso no form
      fk_idtipocomando: ['6', [Validators.required]], // 6 = ACIONAR_RELE
      fk_idlocalacesso: [null],
      com_parametros: [1], // rele_selecionado, // default 1
      dis_sentido: ['E']

    });

    // https://embed.plnkr.co/plunk/jCDw5L
    this.typeaheadAutorizadoPor
      .pipe(
        debounceTime(500),
        switchMap(term => this.getUsuariosPorSetorNomeEPerfil(term))
      )
      .subscribe(items => {
        this.cd.markForCheck();/**/
      }, (err) => {
        this.cd.markForCheck();/**/
      });

    // https://embed.plnkr.co/plunk/jCDw5L
    this.typeaheadDispositivo
      .pipe(
        debounceTime(500),
        switchMap(term => this.getDispositivos(term))
      )
      .subscribe(items => {
        this.cd.markForCheck();/**/
      }, (err) => {
        this.cd.markForCheck();/**/
      });

    this.apiService.getUser().then((res: Login) => {
      this.user = res;

      setTimeout(() => {
        this.loadAsyncSession();
      }, 100);

    });

  }
  //#endregion

  //#region CRUD

  async onSubmit() {
    try {

      this.submitted = true;

      // stop here if form is invalid
      if (this.form.invalid) {
        return;
      }

      if (this.form.value.fk_idtipocomando == 'M') {
        this.onSubmitHistorico();
        return;
      }

      let body = {
        ...this.form.value,
        fk_idconta: this.user.idConta
      }

      this.loading[0] = true;

      const data = await this.apiService.createComando(body);

      this.apiService.showToast(null, 'liberacaomanual.created', 'success');

      this.saveState();

      // close this popup and pass result value
      this.activeModal.close(body);

    } catch (error) {

      this.apiService.errorMessageShow(error);

    } finally {
      this.loading[0] = false;
    }
  }

  async onSubmitHistorico() {
    try {
      
      let dispositivoSelecionado: any = this.dispositivoView || this.state.dispositivoView

      let localacesso

      let sentido = dispositivoSelecionado.dis_sentido || this.form.value.dis_sentido

      if (dispositivoSelecionado) {

        localacesso = dispositivoSelecionado.fk_idlocalacesso

        if (!localacesso && dispositivoSelecionado.dis_locais) {
          localacesso = dispositivoSelecionado.dis_locais[0]
        }

      }

      let body = {
        fk_idconta: this.user.idConta,
        fk_iddispositivo: (dispositivoSelecionado && dispositivoSelecionado.pk_iddispositivo) || this.form.value.fk_iddispositivo,
        fk_idlocalacesso: localacesso,
        fk_idusuario: this.form.value.fk_idusuario,
        fk_idveiculo: this.form.value.fk_idveiculo,
        fk_idsetor: this.form.value.fk_idsetor,
        his_sentido: sentido, // default entrada  
        his_tipo: "M",// Acesso manual
        his_liberado: true
      };

      this.loading[0] = true;

      const data = await this.apiService.createHistorico(body);

      this.apiService.showToast(null, 'liberacaomanual.created', 'success');

      // close this popup and pass result value
      this.activeModal.close(body);

    } catch (error) {

      this.apiService.errorMessageShow(error);

    } finally {
      this.loading[0] = false;
    }
  }



  //#endregion

  //#region USUARIO
  async getUsuariosPorSetorNomeEPerfil(term: string = null, offset: number = 0) {

    try {

      if (term == null || term.length <= 3)
        return

      this.state.is404[2] = false;
      this.loading[2] = true;

      let params = {
        searchQuery: term,
        offset,
        status: 'A',
      }

      let data = await this.apiService.getUsuariosPorSetorNomeEPerfil(params);

      this.state.pagingUsuarios = data.paging;

      this.loading[2] = false;

      if (offset == 0) {
        this.state.usuarios = data.response;
      } else {
        // Add more row in list
        this.state.usuarios = this.state.usuarios.concat(data.response);
      }



    } catch (error) {

      this.state.usuarios = null;

      this.loading[2] = false;

      if (error && error.status != 401 && error.status != 404) {
        this.apiService.errorMessageShow(error);
      }

      // Nenhum registro foi cadastrado
      this.state.is404[2] = error.status == 404;

    }

  }

  async onClearAutorizadoPor() {

    this.usuarioView = null
    this.veiculoView = null
    this.state.usuarios = null

    // reset
    this.form.patchValue({
      evi_descricao: null,
      evi_idquemautorizou: null,
      fk_idveiculo: null
    });

    this.getUsuariosPorSetorNomeEPerfil();
  }

  async onClickAutorizadoPor() {

    this.getUsuariosPorSetorNomeEPerfil();

  }

  async onChangeAutorizadoPor(event) {

    if (!event) {
      return
    }

    this.usuarioView = event
    this.veiculoView = null

    if (this.usuarioView.pk_idveiculo) {
      this.veiculoView = {
        pk_idveiculo: this.usuarioView.pk_idveiculo,
        vei_nome: this.usuarioView.vei_nome,
        vei_placa: this.usuarioView.vei_placa,
        vei_status: this.usuarioView.vei_status,
        cor_nome: this.usuarioView.nor_nome,
      }
    }

    this.form.patchValue({
      fk_idusuario: this.usuarioView.pk_idusuario,
      fk_idsetor: this.usuarioView.fk_idsetor,
      fk_idveiculo: this.usuarioView.pk_idveiculo,
    })

  }

  // https://stackblitz.com/run?file=src%2Fvirtual-scroll-example.component.ts
  onScrollAutorizadoPor({ end }, searchTerm) {

    if (this.state.usuarios && end + this.numberOfItemsFromEndBeforeFetchingMore >= this.state.usuarios.length) {
      this.onScrollToEndAutorizadoPor(searchTerm);
    }
  }

  // https://stackblitz.com/edit/ng-select-infinite
  // https://github.com/ng-select/ng-select/issues/683
  // https://github.com/ng-select/ng-select/issues/1596#issuecomment-619442786
  async onScrollToEndAutorizadoPor(searchTerm) {

    if (this.loading[2] ||
      !this.state.usuarios ||
      !this.state.pagingUsuarios ||
      this.state.usuarios.length >= this.state.pagingUsuarios.total) {
      return;
    }

    var currentOffset = this.state.usuarios.length;

    await this.getUsuariosPorSetorNomeEPerfil(searchTerm, currentOffset);/**/

  }
  //#endregion

  //#region DISPOSITIVO
  async getDispositivos(term: string = null, offset: number = 0) {

    try {

      this.state.is404[3] = false;
      this.loading[3] = true;

      let params = {
        searchQuery: term,
        offset: offset
      }

      let data = await this.apiService.getDispositivosStatus(params);

      this.state.pagingDispositivos = data.paging;

      this.loading[3] = false;

      if (offset == 0) {
        this.state.dispositivos = data.response;
      } else {
        // Add more row in list
        this.state.dispositivos = this.state.dispositivos.concat(data.response);
      }

    } catch (error) {

      this.state.dispositivos = null;

      this.loading[3] = false;

      if (error && error.status != 401 && error.status != 404) {
        this.apiService.errorMessageShow(error);
      }

      // Nenhum registro foi cadastrado
      this.state.is404[3] = error.status == 404;

    }

  }

  async onClearDispositivo() {

    this.dispositivoView = null;
    this.state.leitores = null;

    // reset
    this.form.patchValue({
      fk_iddispositivo: null,
      fk_idleitor: null
    });

    this.getDispositivos();
  }

  async onClickDispositivo() {

  }

  async onChangeDispositivo(event) {

    this.dispositivoView = event;

    this.loadLeitores(this.dispositivoView);

  }

  async onChangeLeitor(event) {

    let leitorSelecionado = event;

    if (!leitorSelecionado) {
      this.form.patchValue({
        fk_idleitor: null
      })
      return;
    }

    // O número do relé é o número do dispositivo
    this.form.patchValue({
      com_parametros: leitorSelecionado.dis_numero,
      fk_idlocalacesso: leitorSelecionado.fk_idlocalacesso,
      dis_sentido: leitorSelecionado.dis_sentido
    })

  }

  loadLeitores(d: any) {

    if (d && d.leitores_json) {
      this.state.leitores = d.leitores_json;

      let leitorSelecionado = this.state.leitores[0];

      // leitor default selecionado
      this.form.patchValue({
        fk_idleitor: leitorSelecionado.pk_iddispositivo
      })

      this.onChangeLeitor(leitorSelecionado);
    } else {
      this.state.leitores = null;
      this.form.patchValue({
        fk_idleitor: null
      })

    }

  }

  // https://stackblitz.com/run?file=src%2Fvirtual-scroll-example.component.ts
  onScrollDispositivo({ end }, searchTerm) {

    if (this.state.dispositivos && end + this.numberOfItemsFromEndBeforeFetchingMore >= this.state.dispositivos.length) {
      this.onScrollToEndDispositivo(searchTerm);
    }
  }

  // https://stackblitz.com/edit/ng-select-infinite
  // https://github.com/ng-select/ng-select/issues/683
  // https://github.com/ng-select/ng-select/issues/1596#issuecomment-619442786
  async onScrollToEndDispositivo(searchTerm) {

    if (this.loading[3] ||
      !this.state.dispositivos ||
      !this.state.pagingDispositivos ||
      this.state.dispositivos.length >= this.state.pagingDispositivos.total) {
      return;
    }

    var currentOffset = this.state.dispositivos.length;

    await this.getDispositivos(searchTerm, currentOffset);/**/

  }
  //#endregion


  //#region OTHERS
  async loadAsyncSession() {

    try {

      if (this.usuarioView && this.usuarioView.usu_status == 'I') {

        this.apiService.errorMessageShow('1178');
        // close this popup and pass result value
        this.activeModal.close(null);
        return;

      }

      let data = await this.apiService.getStorageLocal('liberacaomanual_list');

      if (data) {
        // load from cache
        this.state = data;

      } else {
        // load from backend
        await this.getDispositivos();
      }

      let dataForm = await this.apiService.getStorageLocal('liberacaomanual_form');

      if (dataForm) {
        this.form.patchValue(dataForm);
        // limpando dados da pessoa anterior
        this.form.patchValue({
          fk_idusuario: null,
          fk_idsetor: null,
          fk_idveiculo: null
        })
      }

      if (this.dispositivoView) {
        this.form.patchValue({
          fk_iddispositivo: this.dispositivoView.pk_iddispositivo
        })

        this.loadLeitores(this.dispositivoView);

      }

      if (this.usuarioView) {

        this.state.usuarios = [{
          pk_idusuario: this.usuarioView.pk_idusuario,
          usu_nome: this.usuarioView.usu_nome
        }]

        this.form.patchValue({
          fk_idusuario: this.usuarioView.pk_idusuario,
          fk_idsetor: this.usuarioView.fk_idsetor
        })
      }

      if (this.veiculoView) {

        this.form.patchValue({
          fk_idveiculo: this.usuarioView.pk_idveiculo
        })

      }

    } catch (error) {
      console.error(error);
    }

  }

  async onRefresh() {


  }

  //#endregion

  // save cache  
  saveState() {
    // Local storage
    this.apiService.setStorageLocal('liberacaomanual_form', this.form.value);
    this.apiService.setStorageLocal('liberacaomanual_list', this.state);
  }
  //#endregion

}
